import { render, staticRenderFns } from "./index.vue?vue&type=template&id=307fabaf&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=307fabaf&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "307fabaf",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/vagrant/git/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('307fabaf')) {
      api.createRecord('307fabaf', component.options)
    } else {
      api.reload('307fabaf', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=307fabaf&scoped=true", function () {
      api.rerender('307fabaf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/contract/index.vue"
export default component.exports